import { Entity, JobStartType, JobViewType } from '../..';
import { Location, WorkOrderStatus, AdvancedJobEntity, Appointment, PrimaryTechnician, Label } from '../../entities';


export enum JobProcessingType {
    NavigateToSite = 'NavigateToSite',
    ArriveAtSite = 'ArriveAtSite',
    Start = 'Start',
    CheckOut = 'CheckOut',
    Hold = 'Hold',
    Complete = 'Complete',
    Finalise = 'Finalise',
    Invoice = 'Invoice',
    Paid = 'Paid',
    Close = 'Close',
    Assign = 'Assign',
    UnAssign = 'UnAssign',
    Dispatch = 'Dispatch',
    New = 'New',
    Reissue = 'Reissue',
    WorkOrderUpdate = 'WorkOrderUpdate',
    JobUpdate = 'JobUpdate',
    ResumeNew = 'ResumeNew',
    ResumeAssigned = 'ResumeAssigned',
    WorkOrderDeleted = 'WorkOrderDeleted',
    WorkOrderAddCode = 'WorkOrderAddCode',
    WorkOrderUpdatedCode = 'WorkOrderUpdatedCode',
    WorkOrderDeletedCode = 'WorkOrderDeletedCode',
    AnswerComplianceQuestions = 'WorkOrderAnswersComplianceQuestion',
    SubcontractorDispatch = 'SubcontractorDispatch',
    SubcontractorUnAssign = 'SubcontractorUnAssign',
    SubcontractorNew = 'SubcontractorNew',
    MarkCompliance = 'MarkCompliance',
    AppointmentUpdated = 'AppointmentUpdated'
}

export interface JobProcessingRequest {
    jobId: string;
    type: JobProcessingType;
    note?: string;
    date?: Date;
    user?: Entity;
    status?: string;
    signature?: string; // for complete
    startType?: JobStartType; // for start
    selectedViewMode?: JobViewType;
    isResume?: boolean;
    isSubcontractor?: boolean;
    timestamp: string;
    cancelAppointments?: boolean;
    location?: Location;
    systemStatusName?: string;
}

export interface JobProcessingDataRequest {
    jobId: string;
    systemStatusName: string;
    note?: string;
    date?: Date;
    updatedAt?: string;
    jobStatusCanBeChanged?: boolean;
}

export interface WorkOrderProcessingDataRequest {
    jobId: string;
    workOrderId: string;
    systemStatusName: string;
    note?: string;
    date?: Date;
    updatedAt?: string;
    location?: Location;
    technician?: Entity;
    cancelAppointments?: boolean;
    //TODO: remove the allocationId if no longer use it.
    allocationId?: string;
    allocationIds?: string[];
    mobile?: boolean;
    originalStatusName?: string;
    reverse?: boolean;
    reverseNote?: string;
    completedSignatureName?: string;
    completedSignature?: string;
    affectedWorkOrder?: boolean;
    fromSupervisor?: boolean;
    skipMandatoryTasks?: boolean;
    skipReason?: string;
    otherSkipReason?: string;
    validationOnly?: boolean;
    deleteValidation?: boolean;
}

export interface ClaimWorkOrderProcessingDataRequest extends WorkOrderProcessingDataRequest {
    claimToken?: string;
}

export interface WorkOrderProcessFields {
    status?: WorkOrderStatus;
    technician?: AdvancedJobEntity;
    resources?: PrimaryTechnician[];
    completedDate?: Date;
    completedNote?: string;
    finalisedDate?: Date;
    finalisedNote?: string;
    notifyTechnician?: boolean;
    subcontractor?: AdvancedJobEntity;
    version?: number;
    previousStatus?: AdvancedJobEntity;
    appointments?: Appointment[];
    additionalNote?: string;
    contractorResources?: PrimaryTechnician[];
    completedSignatureName?: string;
    completedSignature?: string;
    completedBy?: Entity;
    finalisedBy?: Entity;
    claimToken?: string;
    systemLabels?: Label[]
}

export interface WorkOrderProcessUpdateRequest {
    workOrderId: string;
    updatedAt: string;
    fields: WorkOrderProcessFields;
}


export enum WorkOrderProcessingType {
    CheckedOut = 'Checked Out',
    Cancelled = 'Cancelled',
    Billed = 'Billed',
    Closed = 'Closed',
    Assigned = 'Assigned',
    Completed = 'Completed',
    Onsite = 'Onsite',
    Paid = 'Paid',
    Dispatched = 'Dispatched',
    OnHold = 'On Hold',
    New = 'New',
    Enroute = 'Enroute',
    InProgress = 'InProgress',
    Finalised = 'Finalised',
    UnAssigned = 'UnAssigned',
    Reissue = 'Reissue',
    ResumeNew = 'ResumeNew',
    ResumeAssigned = 'ResumeAssigned',
    SubcontractorNew = 'SubcontractorNew',
    SubcontractorResumeAssigned = 'SubcontractorResumeAssigned',
    SubcontractorResumeNew = 'SubcontractorResumeNew',
    SubcontractorDispatch = 'SubcontractorDispatch',
    SubcontractorUnAssign = 'SubcontractorUnAssign',
    JobResumeNewOrAssigned = 'JobResumeNewOrAssigned',
    Updated = 'Updated',
    RunsheetDispatched = 'RunsheetDispatched',
    RunsheetUnAssigned = 'RunsheetUnAssigned',
    AppointmentDispatched = 'AppointmentDispatched',
    RunsheetDeleted = 'RunsheetDeleted',
    WorkOrderDeleted = 'WorkOrderDeleted',
    Reverse = 'Reverse',
}

export interface WorkOrderProcessingValidationRequest {
    jobId: string;
    workOrderId?: string;
    systemStatusName: string;
    action?: 'delete' | 'update';
}

export interface WorkOrderProcessingValidationResponse {
    valid: boolean;
    messages?: string[];
}